// store/modules/departmentstates.js

const loadState = () => {
    try {
        const serializedState = localStorage.getItem('departmentStates')
        if (serializedState === null) {
            return { expandedDepartments: {} }
        }
        return JSON.parse(serializedState)
    } catch (err) {
        console.error('Error loading department states:', err)
        return { expandedDepartments: {} }
    }
}

const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state)
        localStorage.setItem('departmentStates', serializedState)
    } catch (err) {
        console.error('Error saving department states:', err)
    }
}

const state = () => loadState()

const mutations = {
    setExpandedDepartments(state, payload) {
        state.expandedDepartments = payload
        saveState(state)
    },
    toggleDepartment(state, departmentName) {
        const newState = { ...state.expandedDepartments }
        const current = newState[departmentName]

        // Treat undefined as "currently true" (expanded by default)
        const effectiveCurrent = current === undefined ? true : current

        newState[departmentName] = !effectiveCurrent

        state.expandedDepartments = newState
        saveState(state)
    }
}

const actions = {
    setExpandedDepartments({ commit }, payload) {
        commit('setExpandedDepartments', payload)
    },
    toggleDepartment({ commit }, departmentName) {
        commit('toggleDepartment', departmentName)
    }
}

const getters = {
    expandedDepartments: (state) => state.expandedDepartments
}

export default {
    state,
    mutations,
    actions,
    getters
}
